import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomItemVerticalTwoAndThreeSelectionComponent } from './custom-item-vertical-two-and-three-selection.component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [CustomItemVerticalTwoAndThreeSelectionComponent],
  exports: [CustomItemVerticalTwoAndThreeSelectionComponent],
    imports: [
        CommonModule,
        I18nModule,
        MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ItemVerticalTwoAndThreeSelectionComponent: {
                    component: CustomItemVerticalTwoAndThreeSelectionComponent,
                },
            },
        } as CmsConfig),
        RouterModule,
    ]
})
export class CustomItemVerticalTwoAndThreeSelectionModule { }
